module.exports = __webpack_public_path__ + "static/media/globe-americas.1f4ead63.svg";